// The app's providers: the shared sign-in session, for useSession and the
// route gates, and the query cache, dropped whenever someone else signs in.
// The Redux store is provided in App.
import { ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { SessionProvider, useSession } from "@jkast90/kast-common/auth";
import { useCacheScopedToUser } from "@jkast90/kast-common/query-client";
import { session } from "../../auth/session";
import { queryClient } from "../queryClient";
import { ReduxInitializer } from "./ReduxInitializer";

interface AppProvidersProps {
  children: ReactNode;
}

function CacheScope() {
  useCacheScopedToUser(queryClient, useSession().user?.sub || null);
  return null;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <SessionProvider session={session}>
      <QueryClientProvider client={queryClient}>
        <CacheScope />
        <ReduxInitializer>{children}</ReduxInitializer>
      </QueryClientProvider>
    </SessionProvider>
  );
}
